import type { PostClientOnboardingTourSeen } from "@/server-types";
import { post } from "../request-helpers";
import { useCustomMutation } from "../custom-mutation";

/**
 * POST /client/onboarding-tour/seen
 */
export const usePostOnboardingTourSeen = () => {
  return useCustomMutation({
    mutationFn: () =>
      post<PostClientOnboardingTourSeen>("/client/onboarding-tour/seen", {}),
  });
};
